import { render, staticRenderFns } from "./HeaderMainSearchResultsDropdown.vue?vue&type=template&id=91a96706&scoped=true&"
import script from "./HeaderMainSearchResultsDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderMainSearchResultsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainSearchResultsDropdown.vue?vue&type=style&index=0&id=91a96706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a96706",
  null
  
)

export default component.exports